import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { apiService } from '../services/apiService';
import { useAuth } from '../context/AuthContext';

const Notes: React.FC = () => {
  const { authenticated, keycloak } = useAuth();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (keycloak?.token) apiService.setToken(keycloak.token);
      setLoading(true);
      setError(null);
      try {
        const resp = await apiService.listNotes();
        if (cancelled) return;
        setItems(Array.isArray(resp.data?.items) ? resp.data.items : (Array.isArray(resp.data?.notes) ? resp.data.notes : []));
      } catch (e: any) {
        setError('Failed to load notes');
      } finally {
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [authenticated, keycloak?.token]);

  const handleDelete = async (id: number) => {
    try {
      await apiService.deleteNote(id);
      setItems(items.filter((x) => x.id !== id));
    } catch {}
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>My Notes</Typography>
      {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
      <Paper sx={{ p: 2 }}>
        {loading ? (
          <Typography>Loading…</Typography>
        ) : (
          <List>
            {items.map((n: any) => (
              <ListItem key={n.id} secondaryAction={<IconButton edge="end" aria-label="delete" onClick={() => handleDelete(n.id)}><DeleteIcon /></IconButton>}>
                <ListItemText primary={(n.text || '').slice(0, 120)} secondary={`bill_id=${n.bill_id}${n.version ? ` • v=${n.version}` : ''}`} />
              </ListItem>
            ))}
            {items.length === 0 && <Typography variant="body2">No notes yet.</Typography>}
          </List>
        )}
      </Paper>
    </Box>
  );
};

export default Notes;
